/* diamond meta data*/
const diamondMetaData = {
  buyDiamondTooltipTxt: "Buy only loose diamond",
  chooseDiamondTooltipTxt: "Choose diamond for build a ring",
  components: {
    DiamondHintPopupComp,
    DiamondEmailPopupComp,
    RequestDiamondImgPopupComp,
    TooltipComp,
    AttrTipComp,
    ChangeOptionPopupComp,
    SocialIconComp,
    diamondConfirmationPopup,
    waitLoader,
    StickyMobileBarComp,
    DiamondSoldOutPopup,
    DiamondInCartPopup,
  },
  data() {
    return {
      showSoldOutPopup: false,
      soldOutDiamond: null,
      showInCartPopup: false,
      inCartLine: null,
      replaceDiamond: "",
      openConfPopup: false,
      waitLoader: false,
      openHintPopup: false,
      openEmailPopup: false,
      openRequestDiamondImgPopup: false,
      buttonText: "BUY DIAMOND LOOSE",
      buttonClicked: false,
      showBtnLoader: false,
      shipsByDate: "",
      showBtnTooltip: false,
      btnTooltipText: "",
      btnTooltipClass: "",
      showSocialIconDiv: false,
      shareTooltip: false,
      addToCartButtonShouldShow: true,
      loadingGIF: `${baseAssetsUrl}/loading.gif`,
      getDiamondShippingDays: "",
      newlayout: false,
      coupon_ring_img: `${baseAssetsUrl}/coupon_studs.png`,
      chooseBtnTextString: "",
      isSendHintModalOpen: false,
      setting: '',
      firstDiamondText: "Add the First Diamond",
      piDetailsOpen: true,
      piShipOpen: false,
      piWarrantyOpen: false,
      /* sessionStorage only -- the opt-in dies with the tab
         (snippets/free-gift.liquid). */
      rbGiftToggle: sessionStorage.getItem('apply_free_gift') === 'true',
    };
  },
  props: [
    "productStatus",
    "diamond",
    "isInWishlist",
    "wishlistText",
    "showTooltip",
    "wishlistClass",
    "showWishlistLoader",
    "showChangeDiamondConfirm",
    "isDiamondImgError",
    "chooseButtonText",
    "chooseShowBtnLoader",
    "changeDiamondWaringMsg",
    "isPrimary",
  ],
  emits: ["parentAddToWishlist", "chooseDiamond", "changeDiamond"],
  delimiters: ["[[", "]]"],
  template: `#diamond-metadata`,
  watch: {
    rbGiftToggle(newVal) {
      var strVal = newVal ? 'true' : 'false';
      if (sessionStorage.getItem('apply_free_gift') !== strVal) {
        sessionStorage.setItem('apply_free_gift', strVal);
        window.dispatchEvent(new CustomEvent('freeGiftToggleChanged', { detail: { checked: newVal } }));
        /* Act on the real cart straight away, the way the PDP and the drawer
           do -- a cart that already clears the threshold gets the gift the
           moment the box is ticked, and loses it the moment it is unticked,
           instead of waiting for the shopper to reach /cart.
           (snippets/free-gift.liquid) */
        if (typeof window.ensureFreeGiftInCart === 'function') window.ensureFreeGiftInCart();
      }
    },
    "$route.params.diamondId": {
      handler(diamondId) {
        if (diamondId != undefined) {
          this.buttonText = "BUY DIAMOND LOOSE";
          this.buttonClicked = false;
          this.getShipsByDate();
        }
      },
      immediate: true,
    },
    chooseButtonText() {
      if (!!this.$props.chooseButtonText) {
        this.chooseBtnTextString = this.$props.chooseButtonText;
      }
    },
  },
  computed: {
    /* Opened from a cart line: sections/cart-template.liquid stamps the diamond
       row's title link with a cart_ctx blob. That stone is already bought, so
       "Buy Diamond Loose" / "Choose this Diamond" have nothing left to do here
       and would only risk a duplicate line — the CTAs collapse to a single way
       back to the cart. */
    cameFromCart() {
      return !!this.$route.query.cart_ctx;
    },
    getPopupTitle() {
      var title = getDiamondTitle(this.$props.diamond);
      return title;
    },
    getPopupImage() {
      return this.$props.diamond.diamondImage;
    },
    getPopupPlaceholderImage() {
      return this.$props.diamond.shape;
    },
    getConfirmPopupTitle() {
      var title = getDiamondTitle(this.$props.diamond);
      return '"' + title + '"';
    },
    getPageTitle() {
      return getDiamondTitle(this.$props.diamond, this.$props.diamond.diamondType);
    },
    getFormattedPrice() {
      return (currencySymbol, price) => {
        const newPrice = !price
          ? "N/A"
          : `${currencySymbol}${parseFloat(price).toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`;

        return newPrice.split(".")[0];
      };
    },
    getNormalFormattedPrice() {
      return (price) => {
        const newPrice = !price
          ? "N/A"
          : `${parseFloat(price).toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`;

        return newPrice.split(".")[0];
      };
    },
    getContactPhoneNumber() {
      return contactTelephoneNumber;
    },
    getTelephoneLink() {
      return `tel:${contactTelephoneNumber.replace(/[^0-9]/g, "")}`;
    },
    getPageUrl() {
      return `${baseUrl}/collections/${this.$route.params.diamondTab}/diamonds?diamondId=${this.$route.query.diamondId}`;
    },
    getDiamondReturnDays() {
      return diamondReturnDays;
    },
  },
  mounted() {
    if (!!this.$props.chooseButtonText) {
      this.chooseBtnTextString = this.$props.chooseButtonText;
    }
    this.getDiaShippingDays();
    this.addToCartButtonShouldShow =
      !window.sessionStorage.getItem("selectedSetting");
    var local = localStorage.getItem("new-layout");
    this.newlayout = !!local;
    if (!local) {
      this.buttonText = "BUY DIAMOND LOOSE";
      // this.diamondMRP = parseFloat(this.$props.diamond.finalPrice).toFixed(2) + 500
    }
    // this.addToCart()
    const saved = sessionStorage.getItem("selectedSetting");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        this.setting = parsed;
      } catch (e) {
        console.error("Session setting parse error:", e);
      }
    }
    const selectedDiamond = sessionStorage.getItem("selectedDiamond");
    if (selectedDiamond) {
      this.firstDiamondText = "Add the Second Diamond";
    }
    window.addEventListener("freeGiftToggleChanged", (e) => {
      if (this.rbGiftToggle !== e.detail.checked) {
        this.rbGiftToggle = e.detail.checked;
      }
    });
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        var hasGift = cart.items && cart.items.some((i) => i.variant_id === 67834200031596 || (i.properties && i.properties._gift));
        if (hasGift) {
          this.rbGiftToggle = true;
          sessionStorage.setItem("apply_free_gift", "true");
        }
      })
      .catch(() => {});
  },
  methods: {
    getAfterpayPrice() {
      if (!this.diamond.finalPriceAud) return 0;

      const price = parseFloat(this.diamond.finalPriceAud);
      if (
        (this.diamond.diamondType === 'lab' ||
          this.diamond.diamondType === 'lab_color') &&
        price >= 500
      ) {
        return (price * 0.70).toFixed(2);
      }
      return price.toFixed(2);
    },
    isLabDiscounted(priceAud, diamondType) {
      var price = parseFloat(priceAud);
      return (
        (diamondType === 'lab' || diamondType === 'lab_color') &&
        !isNaN(price) && price >= 500
      );
    },
    applyLabDiscount(priceAud, diamondType) {
      var price = parseFloat(priceAud);
      if (this.isLabDiscounted(priceAud, diamondType)) {
        return Math.round(price * 0.70);
      }
      return Math.round(price || 0);
    },
    finalDiamondPrice() {
      var price = parseFloat(this.diamond.finalPriceAud);
      if (isNaN(price)) return 0;
      return this.isLabDiscounted(this.diamond.finalPriceAud, this.diamond.diamondType)
        ? Math.round(price * 0.70)
        : Math.round(price);
    },
    diamondSavings() {
      var price = parseFloat(this.diamond.finalPriceAud);
      if (isNaN(price)) return 0;
      return this.isLabDiscounted(this.diamond.finalPriceAud, this.diamond.diamondType)
        ? Math.round(price) - Math.round(price * 0.70)
        : 0;
    },
    toggleSendHintModal() {
      this.isSendHintModalOpen = !this.isSendHintModalOpen;
    },
    async copyCoupon(code) {
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.handleBtnTooltip("show", "copyCoupons");

      setTimeout(() => {
        this.handleBtnTooltip("hide", "copyCoupons");
      }, 2000);
    },
    closeConfirmationPopup() {
      this.openConfPopup = false;
    },
    openHintPopupForm() {
      let diamondData = this.$props.diamond;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "Y9rtKH"]);
      setTimeout(() => {
        if (
          !!document.querySelector(".needsclick.kl-private-reset-css-Xuajs1")
        ) {
          document.querySelector("#Product_URL_101478013").value =
            window.location.href;
          document.querySelector(
            "#rich-text-99188707 span.ql-font-poppins"
          ).innerText = `${diamondData.caratWeight} Carat ${diamondData.shape}`;
          document.querySelector(
            "img.needsclick.kl-private-reset-css-Xuajs1"
          ).src =
            !!diamondData.diamondImage &&
              diamondData.diamondImage.toLowerCase() == "na"
              ? `${window.location.origin}/cdn/shop/t/9/assets/${diamondData.shape}.png`
              : diamondData.diamondImage;
        }
      }, 1000);
      /* let product = this.$props.diamond
            axios.post('https://a.klaviyo.com/api/track', {
            token: 'XDiazs',
            event: 'Product Viewed',
            properties: {
                    productName: `${product.caratWeight} Carat ${product.shape}`,
                    productId: product.diamondId,
                    productImage: product.diamondImage 
                    // Add any other relevant product data here
                }
            })
            .then(response => {
                // Once the data is sent successfully, open the Klaviyo form
                window._klOnsite = window._klOnsite || [];
                window._klOnsite.push(['openForm', 'Y9rtKH']);
            })
            .catch(error => {
                console.error('Error sending data to Klaviyo:', error);
            }); */
    },
    showIconSection() {
      if (this.showSocialIconDiv) {
        clearTimeout(this.iconTimeout); // Clear any existing timeout
        this.showSocialIconDiv = false;
      } else {
        this.showSocialIconDiv = true;
        this.iconTimeout = setTimeout(() => {
          this.showSocialIconDiv = false;
        }, 5000);
      }
    },

    getDiaShippingDays() {
      var week = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      var month = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let date = new Date(
        new Date(new Date()).setDate(new Date(new Date()).getDate() + 15)
      );
      this.getDiamondShippingDays = `${week[date.getDay()]}, ${month[date.getMonth()]
        } ${date.getDate()}`;
    },
    changeCurrentOption(action) {
      this.$emit("changeDiamond", action);
    },
    handleBtnTooltip(action, btnType, value = undefined) {
      var tooltipTxt;
      if (btnType == "diamondOnly") {
        tooltipTxt = action == "show" ? this.$options.buyDiamondTooltipTxt : "";
        btnTooltipClass = action == "show" ? "pc-buy-diamond" : "";
      } else if (btnType == "copy") {
        tooltipTxt = action == "show" ? "Link Copied" : "";
        btnTooltipClass = action == "show" ? "pc-buy-diamond" : "";
      } else if (btnType == "copyCoupons") {
        tooltipTxt = action == "show" ? "Coupon Code Copied!" : "";
        btnTooltipClass = action == "show" ? "pc-buy-diamond" : "";
      } else if (btnType == "out of stock") {
        tooltipTxt =
          action == "show" ? "Sorry, This product is out of stock" : "";
        btnTooltipClass = action == "show" ? "pc-buy-diamond" : "";
      } else if (btnType == "redirecting") {
        tooltipTxt =
          action == "show" ? `You are redirecting to ${value} page` : "";
        btnTooltipClass = action == "show" ? "pc-buy-diamond" : "";
      } else if (btnType == "already_exists") {
        tooltipTxt = action == "show" ? `${value}` : "";
        btnTooltipClass = action == "show" ? "pc-buy-diamond" : "";
      } else if (btnType == "product_not_found") {
        tooltipTxt = action == "show" ? `${value}` : "";
        btnTooltipClass = action == "show" ? "pc-buy-diamond" : "";
      } else {
        tooltipTxt =
          action == "show" ? this.$options.chooseDiamondTooltipTxt : "";
        btnTooltipClass = action == "show" ? "pc-choose-diamond" : "";
      }
      this.btnTooltipText = tooltipTxt;
      this.btnTooltipClass = btnTooltipClass;
      this.showBtnTooltip = action == "show" ? true : false;
    },
    checkStockIfSatusEmpty(datas, func, event = undefined) {
      if (func == "chooseDiamond") {
        this.$emit("chooseDiamond");
      } else if (func == "addToCart") {
        this.addToCart(event);
      }
    },
    /* Re-check the diamond against the live feed before buying/selecting it.
       On sold-out: clears the matching selection, opens the popup, returns false.
       On available/unknown (feed unreachable): returns true (fail-open pre-checkout). */
    async verifyDiamondAvailable(diamond) {
      if (!window.ROADiamond) return true;
      const status = await window.ROADiamond.checkAvailability({
        diamondId: diamond.diamondId,
        diamondType: diamond.diamondType,
      });
      if (status === "soldout") {
        window.ROADiamond.clearBuilderSelection(diamond.diamondId);
        this.soldOutDiamond = diamond;
        this.showSoldOutPopup = true;
        return false;
      }
      return true;
    },
    async addDiamond(e) {
      if (!(await this.verifyDiamondAvailable(this.$props.diamond))) return;
      if (sessionStorage.getItem("selectedSetting")) {
        const selectedSetting = JSON.parse(
          sessionStorage.getItem("selectedSetting")
        );
        const selectedDiamond = JSON.parse(
          sessionStorage.getItem("selectedDiamond")
        );
        const currentDiamond = this.$props.diamond;

        // agar secondShapes available hai
        let allowedShapes = [];
        if (selectedSetting?.secondShapes?.trim()) {
          try {
            allowedShapes = JSON.parse(selectedSetting?.secondShapes?.trim());
            // yeh array ke andar objects hai, unse shape extract karte hain
            allowedShapes = allowedShapes.map((obj) => Object.values(obj)[0]);
          } catch (err) {
            console.error("Invalid secondShapes JSON:", err);
          }
        }
        const isSecondDiamondSearching = sessionStorage.getItem(
          "searchingSecondDiamond"
        );

        if (
          selectedSetting.type == "Engagement Rings" &&
          selectedSetting.tags.includes("toi-et-moi") &&
          selectedDiamond &&
          selectedDiamond.diamondId !== currentDiamond.diamondId &&
          isSecondDiamondSearching
        ) {
          if (
            allowedShapes.length > 0 &&
            !allowedShapes.includes(currentDiamond.shape)
          ) {
            alert(
              `This diamond shape (${currentDiamond.shape}) is not allowed for this setting.`
            );
            return;
          }

          // agar shape allowed hai to proceed
          sessionStorage.setItem(
            "selectedSecondDiamond",
            JSON.stringify(currentDiamond)
          );
          // buildFinalRingUrl (ring-builder-common-components.js) is the single
          // source of truth for this URL's shape — it reads selectedSecondDiamond
          // (just written above) from sessionStorage and includes it automatically.
          // No data= payload: selectedSetting/selectedSecondDiamond are already
          // in sessionStorage (this is a same-browser redirect) and final-ring's
          // mounted() reads them from there — avoids risking a 414 on rich settings.
          var href = buildFinalRingUrl({
            settingId: selectedSetting.id,
            diamondId: selectedDiamond?.diamondId,
            diamondType: selectedDiamond?.diamondType,
          });
          if (href) window.location.href = `${baseUrl}${href}`;
          return;
        }
      }

      // this.handleBtnTooltip("show", "ringbuilder")
      this.$emit("chooseDiamond");
      // if(this.productStatus == 'Success'){
      // } else if(this.productStatus == '' || !this.productStatus) {
      //     this.chooseBtnTextString = "Checking Stock . . ."
      //     // this.checkStockIfSatusEmpty(this.$props.diamond,"chooseDiamond")

      // }
    },
    setNewImage(targetElement, diamondShape) {
      var stage = parseInt(targetElement.dataset.imgErrorStage || "0");
      targetElement.dataset.imgErrorStage = String(stage + 1);
      if (stage === 0) {
        targetElement.setAttribute("src", getShapeFallbackImage(diamondShape));
      } else if (stage === 1) {
        targetElement.setAttribute("src", shapeToImageUrl.DEFAULT);
      }
    },
    getShipsByDate() {
      var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];
      var daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var currentDate = new Date();
      var daysToAdd = 10;
      currentDate.setDate(currentDate.getDate() + parseInt(daysToAdd));
      this.shipsByDate = `${daysOfWeek[currentDate.getDay()]}, ${monthNames[currentDate.getMonth()]
        } ${currentDate.getDate()}`;
    },
    addCartCheckSatus(e) {
      this.addToCart(e);
      // if(this.productStatus == 'Success'){
      // } else if(this.productStatus == '' || !this.productStatus) {
      //     e.currentTarget.innerText = "Checking Stock . . ."
      //     this.checkStockIfSatusEmpty(this.$props.diamond,"addToCart",e)
      // }
    },
    updateWaitLoader(bool = undefined, message = undefined) {
      this.waitLoader = !!bool;
      this.loaderMessage = message || "";
    },
    diamondPayloadTitle(diamond) {
      // 0.3 Ct. D Color VVS2 Clarity Round Shape Lab Grown Diamond
      const { color, clarity, caratWeight, shape, diamondType } = diamond;
      const diamondT = diamondType == "lab" ? "Lab Grown" : diamondType == "lab_color" ? "Coloured Lab Grown" : diamondType == "white_color" ? "Coloured Natural" : "Natural";
      return `${caratWeight} ct ${color} Colour ${clarity} Clarity ${shape} Shape ${diamondT} Diamond`;
    },
    /* Every diamond line -- loose or inside a final ring -- carries the diamond's
       feed id in properties.sku (see the payloads below and in
       ring-builder-final-ring-detail.js), so that is the identity to match on.
       checkCartData() can't stand in here: it matches product_type against a
       bare "Diamond", which the created products never use. */
    /* The one place this page reads /cart.js. window.ROACart
       (snippets/cart-fetch-dedupe.liquid) shares a single network request
       between every reader on the page. */
    async readCart() {
      if (window.ROACart && typeof window.ROACart.get === "function") {
        return window.ROACart.get();
      }
      const response = await fetch(window.Shopify.routes.root + "cart.js", {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    },

    /* `cart`: the cart addToCart() already read, so this does not fetch again. */
    async findDiamondInCart(diamondId, cart) {
      if (!diamondId) return null;
      try {
        const cartData = cart || (await this.readCart());
        return (
          (cartData.items || []).find(
            (item) =>
              (item.properties && item.properties.sku === diamondId) ||
              item.sku === diamondId
          ) || null
        );
      } catch (error) {
        /* Fail open -- a cart lookup we couldn't make is no reason to block
           the sale; Shopify still enforces the single unit of stock. */
        console.error("Failed to fetch cart data:", error);
        return null;
      }
    },
    async checkCartData(type, id, cart) {
      try {
        const cartData = cart || (await this.readCart());

        // Find the matching product in the cart
        const existingProduct = cartData.items.find(
          (item) => item.product_type === type && item.sku === id
        );

        return existingProduct || null; // Return the product data or null if not found
      } catch (error) {
        console.error("Failed to fetch cart data:", error);
        return false; // Default to false in case of an error
      }
    },
    async createCustomProductWithMetafields(diamondData) {
      const productCreateApiEndpoint =
        window.ShopifyConfig.productCreateApiEndpoint; // Replace with your Admin API access token

      const tempCarat = diamondData?.caratWeight;
      const finalCarat = tempCarat
        ? tempCarat?.replace(".", "-").concat("-carat-diamond")
        : "";

      const bodyData = {
        product: {
          title: this.diamondPayloadTitle(diamondData),
          vendor: "Rings Of Australia",
          product_type:
            diamondData.diamondType === "lab"
              ? "Lab Diamonds"
              : diamondData.diamondType === "lab_color"
                ? "Lab Colour Diamonds"
                : diamondData.diamondType === "white"
                  ? "Natural Diamonds"
                  : diamondData.diamondType === "white_color"
                    ? "Natural Colour Diamonds"
                    : diamondData.diamondType,
          status: "active",
          tags: `Diamonds,hidden,${diamondData.shape || "Shape"},${diamondData.caratWeight}-carat`,
          images: [{ src: diamondData.diamondImage }],
          variants: [
            {
              option1: `Diamond Certificate: ${diamondData.diamondId}`,
              price: diamondData.finalPriceAud,
              sku: diamondData.diamondId,
            },
          ],
        }
      };

      try {
        const response = await fetch(productCreateApiEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
            // "X-Shopify-Access-Token": accessToken,
          },
          body: JSON.stringify(bodyData),
        });

        let responseData = await response.json();
        responseData = responseData;

        if (responseData.product) {
          return responseData.product;
        } else {
          console.error("Failed to create product:", responseData.errors);
          throw new Error("Somthing went wrong! Please try again.");
          return null;
        }
      } catch (error) {
        console.error("Error while creating product:", error);
        throw new Error("Somthing went wrong! Please try again.");
        return null;
      }
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    /* Polls /products/<handle>.js until the product just created for this diamond
       is available on the storefront. Resolves true when it is, false when it
       never becomes so within the backoff schedule — the caller must stop on
       false. Same URL every time (the old ?cacheBust=Date.now() forced Shopify's
       CDN to miss on every poll); cache: 'no-store' keeps the browser from
       replaying a 404 it saw a moment earlier. Backoff 0.8s, 1.5s, 3s, 5s. */
    async checkStorefrontWithRetry(handle, waits = [800, 1500, 3000, 5000]) {
      for (let attempt = 0; ; attempt++) {
        try {
          const res = await fetch(`${window.location.origin}/products/${handle}.js`, {
            cache: "no-store",
          });
          if (res.ok) {
            const data = await res.json();
            if (data?.available) return true;
          }
        } catch (err) {
          /* not there yet — fall through to the wait */
        }
        if (attempt >= waits.length) return false;
        await this.delay(waits[attempt]);
      }
    },
    /* /cart/add.js through the shared retry policy in window.ROACart.add
       (snippets/cart-fetch-dedupe.liquid): 429 -> Retry-After / backoff + jitter
       (max 4 attempts, ~15s) with the button reading "Busy, retrying..."; 422
       "sold out" (the new product still propagating) -> a few 2s retries;
       anything else -> fail at once. Rejects with an Error whose
       .friendlyMessage, when set, is what to show the shopper. */
    async addToCartWithRetryLogic(payload) {
      if (window.ROACart && typeof window.ROACart.add === "function") {
        return window.ROACart.add(payload, {
          url: window.Shopify.routes.root + "cart/add.js",
          onRetry: (info) => {
            this.buttonText =
              info.reason === "busy" ? "Busy, retrying..." : "Adding to cart...";
          },
        });
      }

      // No wrapper on the page: one plain attempt, no retry.
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data?.description || data?.message || "Something went wrong.");
      }
      return data;
    },
    async addToCart(e) {
      this.buttonClicked = true;
      this.showBtnLoader = true;
      this.buttonText = "Loading...";
      e.target.disabled = true;

      const diamondData = this.$props.diamond;

      // Re-check availability before creating a product / adding to cart.
      if (!(await this.verifyDiamondAvailable(diamondData))) {
        this.buttonClicked = false;
        this.showBtnLoader = false;
        this.buttonText = "Buy Diamond Loose";
        e.target.disabled = false;
        return;
      }

      /* One cart read serves the whole pre-flight: the in-cart check and
         checkCartData() below each used to fetch /cart.js on their own. */
      let cart = null;
      try {
        cart = await this.readCart();
      } catch (err) {
        console.error("Failed to fetch cart data:", err);
      }

      /* A diamond is one of a kind, so a repeat add can only ever be a mistake --
         show what is already in the bag rather than bumping the line to qty 2. */
      const cartLine = await this.findDiamondInCart(diamondData.diamondId, cart);
      if (cartLine) {
        this.inCartLine = cartLine;
        this.showInCartPopup = true;
        this.buttonClicked = false;
        this.showBtnLoader = false;
        this.buttonText = "BUY DIAMOND LOOSE";
        e.target.disabled = false;
        return;
      }

      const existingProductData = await this.checkCartData(
        "Diamond",
        diamondData.diamondId,
        cart
      );

      let productData;

      if (!existingProductData) {
        productData = await this.createCustomProductWithMetafields(diamondData);
      }

      if (productData?.handle) {
        // The add below can only bounce (422 "sold out") against a product the
        // storefront cannot see yet — stop with a clear message instead.
        if (!(await this.checkStorefrontWithRetry(productData.handle))) {
          this.btnTooltipText =
            "We couldn't finish preparing your diamond. Please try again in a moment.";
          this.btnTooltipClass = "pc-choose-diamond";
          this.showBtnTooltip = true;
          setTimeout(() => {
            this.showBtnTooltip = false;
          }, 3000);
          this.buttonClicked = false;
          this.showBtnLoader = false;
          this.buttonText = "Buy Diamond Loose";
          e.target.disabled = false;
          e.target.style.pointerEvents = "pointer";
          return;
        }
      }

      if (productData || existingProductData) {
        const payload = {
          items: [
            {
              id: existingProductData
                ? existingProductData?.variant_id
                : productData.variant.id,
              quantity: 1,
              properties: {
                stock_no: diamondData.stockNumber,
                certificate_number: diamondData.certificateNumber,
                sku: diamondData.diamondId,
                stone_shape: diamondData.shape,
                laboratory: diamondData.lab,
                certificate: diamondData.certificateFile,
                carat_weight: diamondData.caratWeight,
                clarity: diamondData.clarity,
                color: diamondData.color,
                stone_type: diamondData?.diamondType == "lab"
                  ? "Lab Diamonds"
                  : diamondData?.diamondType == "lab_color"
                    ? "Lab Colour Diamonds"
                    : diamondData?.diamondType == "white"
                      ? "Natural Diamonds"
                      : diamondData?.diamondType == "white_color"
                        ? "Natural Colour Diamonds"
                        : diamondData?.diamondType,
                cut: diamondData.cut,
                polish: diamondData.polish,
                symmetry: diamondData.symmetry,
                fluorescence: diamondData.flourIntensity
              },
            },
          ],
        };

        this.showBtnLoader = false;
        let isError = 0;

        const button = e.target;

        button.disabled = true;
        button.style.pointerEvents = "none";

        // One shared retry policy (addToCartWithRetryLogic -> window.ROACart.add):
        // 429 -> backoff, 422 "sold out" -> short wait while the new product
        // propagates, anything else -> fail now.
        this.addToCartWithRetryLogic(payload)
          .then(async (data) => {
            this.buttonText = "Added to Cart";
            /* The diamond is in the cart now, so this is the first moment the
               gift's threshold can actually be judged. Settle it here rather
               than leaving it to the cart page's one-shot updateGift(), which
               is what used to let an opted-in shopper check out with no gift.
               (snippets/free-gift.liquid) */
            if (typeof window.ensureFreeGiftInCart === "function") {
              await window.ensureFreeGiftInCart({ navigatingToCart: true });
            }
            window.location.href = "/cart";
          })
          .catch((error) => {
            isError = 1;
            this.buttonText = "Buy Diamond Loose";
            // A 429 that never cleared carries its own wording (ROACart.busyMessage).
            this.btnTooltipText =
              error?.friendlyMessage || "Something went wrong, please try again.";
            this.btnTooltipClass = "pc-choose-diamond";
            this.showBtnTooltip = true;

            setTimeout(() => {
              this.showBtnTooltip = false;
            }, 2000);

            console.error("Add to Cart Error:", error);
          })
          .finally(() => {
            this.showBtnLoader = false;
            this.buttonClicked = false;
            button.disabled = false;
            button.style.pointerEvents = "pointer";
          });
      } else {
        this.btnTooltipText = "Something went wrong, please try again.";
        this.btnTooltipClass = "pc-choose-diamond";
        this.showBtnTooltip = true;
        setTimeout(() => {
          this.showBtnTooltip = false;
          this.showBtnLoader = false;
          this.buttonClicked = false;
          e.target.disabled = false;
          this.buttonText = "Buy Diamond Loose";
          e.target.style.pointerEvents = "pointer";
        }, 2000);
      }
    },

    openFormPopup(e, formType) {
      if (formType === "drop_a_hint") {
        this.openHintPopup = true;
      } else if (formType === "email_us") {
        this.openEmailPopup = true;
      } else if (formType === "request_diamond_img") {
        this.openRequestDiamondImgPopup = true;
      }
    },
    shareButtonPopup(bool) {
      this.shareTooltip = !bool;
    },
    redirectToAppointmentPage() {
      location.href = `${baseUrl}/book-an-appointment`;
    },
  },
};

/* recently viewed diamonds */
const RecentlyViewedItems = {
  props: ["currentDiamondId", "recentDiamonds", "isUniqueItem"],
  emits: ["imageError"],
  data() {
    return {
      isMobileDevice: false,
      currentSlideIndex: 0,
      totalSlides: 0,
      isLabGrownPopupModal: null,
      canScrollLeft: false,
      canScrollRight: true,
      _resizeObs: null,
    };
  },
  mounted() {
    if (window.innerWidth <= 767) {
      this.isMobileDevice = true;
    }
    this.$nextTick(() => {
      this.initCarousel();
      this.scheduleArrowRefresh();
    });
    this._onWindowResize = () => this.updateArrowState();
    window.addEventListener("resize", this._onWindowResize);
  },
  beforeUnmount() {
    this.teardownCarousel();
    if (this._onWindowResize) {
      window.removeEventListener("resize", this._onWindowResize);
    }
  },
  watch: {
    recentDiamonds: {
      handler(val) {
        this.totalSlides = !val || val.length == 0 ? 0 : val.length - 1;
        this.$nextTick(() => {
          this.initCarousel();
          this.scheduleArrowRefresh();
        });
      },
      immediate: true,
      deep: false,
      flush: "post",
    },
  },
  delimiters: ["[[", "]]"],
  template: `#recently-view`,
  computed: {
    getTitle() {
      return (diamond) => {
        return getDiamondTitle(diamond);
      };
    },
    getDiamondLine() {
      return (item) => {
        const parts = [];
        if (item.caratWeight) parts.push(`${parseFloat(item.caratWeight)} Carat`);
        if (item.shape) parts.push(item.shape);
        const typeMap = {
          white: "Natural Diamond",
          lab: "Lab Grown Diamond",
          white_color: "Coloured Natural Diamond",
          lab_color: "Coloured Lab Grown Diamond",
        };
        if (typeMap[item.diamondType]) parts.push(typeMap[item.diamondType]);
        return parts.join(" ");
      };
    },
    orderedRecentDiamonds() {
      const arr = Array.isArray(this.recentDiamonds) ? this.recentDiamonds : [];
      return arr.slice().reverse();
    },
  },
  methods: {
    setLabGrownPopupModal(e, id = null) {
      e.stopPropagation();
      this.isLabGrownPopupModal = id;
    },
    moveSlide(action) {
      var currentSlideIndex = this.currentSlideIndex;
      if (action == "prev") {
        currentSlideIndex--;
        if (currentSlideIndex < 0) {
          currentSlideIndex = this.totalSlides;
        }
      } else {
        currentSlideIndex++;
        if (currentSlideIndex > this.totalSlides) {
          currentSlideIndex = 0;
        }
      }
      this.currentSlideIndex = currentSlideIndex;
    },
    setUrlParam(e, diamondId, diamondType) {
      let compName =
        diamondType == "white" ? "natural-diamonds" : diamondType == "lab" ? "lab-diamonds" : diamondType == "white_color" ? "natural-fancy-coloured-diamonds" : diamondType == "lab_color" ? "coloured-lab-grown-diamonds" : "";
      window.location.href = `/collections/${compName}/diamonds?diamondId=${diamondId}`;
    },
    getTrack() {
      if (this.$el && typeof this.$el.querySelector === "function") {
        const t = this.$el.querySelector(".nrl-recent-track");
        if (t) return t;
      }
      let node = this.$el;
      while (node && node.nodeType !== 1) node = node.nextSibling;
      if (node && typeof node.querySelector === "function") {
        const t = node.querySelector(".nrl-recent-track");
        if (t) return t;
      }
      return document.querySelector(".nrl-recent-track");
    },
    scrollStep(dir) {
      const track = this.getTrack();
      if (!track) return;
      const card = track.querySelector(".nrl-recent-card");
      const cardWidth = card ? card.getBoundingClientRect().width + 20 : 260;
      const visible = Math.max(1, Math.floor(track.clientWidth / cardWidth));
      const delta = dir * cardWidth * visible;
      const max = track.scrollWidth - track.clientWidth;
      const target = Math.max(0, Math.min(max, track.scrollLeft + delta));
      if (typeof track.scrollTo === "function") {
        try {
          track.scrollTo({ left: target, behavior: "smooth" });
        } catch (e) {
          track.scrollLeft = target;
        }
      } else {
        track.scrollLeft = target;
      }
      setTimeout(() => this.updateArrowState(), 350);
    },
    updateArrowState() {
      const track = this.getTrack();
      if (!track) {
        this.canScrollLeft = false;
        this.canScrollRight = false;
        return;
      }
      const max = track.scrollWidth - track.clientWidth;
      this.canScrollLeft = track.scrollLeft > 2;
      this.canScrollRight = max > 2 && track.scrollLeft < max - 2;
    },
    onScroll() {
      this.updateArrowState();
    },
    initCarousel() {
      const track = this.getTrack();
      if (!track) return;
      if (this._boundTrack === track) {
        this.updateArrowState();
        return;
      }
      this.teardownCarousel();
      this._boundTrack = track;
      this._scrollHandler = () => this.onScroll();
      track.addEventListener("scroll", this._scrollHandler, { passive: true });
      if (window.ResizeObserver) {
        this._resizeObs = new ResizeObserver(() => this.updateArrowState());
        this._resizeObs.observe(track);
      }
      const imgs = track.querySelectorAll("img");
      this._imgLoadHandler = () => this.updateArrowState();
      imgs.forEach((img) => {
        if (!img.complete) {
          img.addEventListener("load", this._imgLoadHandler, { once: true });
          img.addEventListener("error", this._imgLoadHandler, { once: true });
        }
      });
      this.updateArrowState();
    },
    scheduleArrowRefresh() {
      const raf =
        window.requestAnimationFrame || ((cb) => setTimeout(cb, 16));
      raf(() => {
        this.updateArrowState();
        raf(() => {
          this.updateArrowState();
          setTimeout(() => this.updateArrowState(), 120);
          setTimeout(() => this.updateArrowState(), 400);
        });
      });
    },
    teardownCarousel() {
      const track = this._boundTrack;
      if (track && this._scrollHandler) {
        track.removeEventListener("scroll", this._scrollHandler);
      }
      if (this._resizeObs) {
        this._resizeObs.disconnect();
        this._resizeObs = null;
      }
      this._boundTrack = null;
    },
    getDiamondSrc(item) {
      if (!item.diamondImage) return getShapeFallbackImage(item.shape);
      return item.diamondImage;
    },
    handleDiamondImgError(e, shape) {
      var target = e.target || e.currentTarget;
      var fallback = getShapeFallbackImage(shape);
      target.removeAttribute("srcset");
      if (target.src === shapeToImageUrl.DEFAULT) return;
      if (target.src === fallback) {
        target.src = shapeToImageUrl.DEFAULT;
      } else {
        target.src = fallback;
      }
    },
  },
};

/* diamond detail page */
const diamondDetailTable = {
  components: {
    RecentlyViewedItems,
  },
  data() {
    return {
      qrcode: new QRious({ size: 90 }),
      isTooltipVisible: "",
    };
  },
  mounted() {
    // Add a click event listener to the document to close the tooltip
    document.addEventListener("click", () => (this.isTooltipVisible = ""));
  },
  beforeDestroy() {
    // Remove the event listener when the Vue component is destroyed
    document.removeEventListener("click", () => (this.isTooltipVisible = ""));
  },
  props: [
    "diamond",
    "currentDiamondId",
    "recentDiamonds",
    "isUniqueItem",
    "showRecentView",
  ],
  delimiters: ["[[", "]]"],
  template: `#diamond-detail-table`,
  computed: {
    newQRCode() {
      this.qrcode.value = `${baseUrl}/collections/${this.$route.params.diamondTab.toLowerCase()}/diamonds?diamondId=${this.$route.query.diamondId
        }`;
      return this.qrcode.toDataURL();
    },
  },
  methods: {
    getNormalFormattedPrice() {
      return (price) => {
        const newPrice = !price
          ? "N/A"
          : `${parseFloat(price).toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`;

        return newPrice.split(".")[0];
      };
    },
    setNewImage(targetElement, diamondShape) {
      var stage = parseInt(targetElement.dataset.imgErrorStage || "0");
      targetElement.dataset.imgErrorStage = String(stage + 1);
      if (stage === 0) {
        targetElement.setAttribute("src", getShapeFallbackImage(diamondShape));
      } else if (stage === 1) {
        targetElement.setAttribute("src", shapeToImageUrl.DEFAULT);
      }
    },
    openPopup(e, num) {
      e.stopPropagation();
      this.isTooltipVisible = this.isTooltipVisible === num ? "" : num;
    },
    closeTooltipOnOutsideClick(event) {
      const tooltip = document.querySelector(".tooltip");
      if (
        this.isTooltipVisible !== "" &&
        tooltip &&
        !tooltip.contains(event.target)
      ) {
        this.isTooltipVisible = "";
      }
    },
  },
};

/* product detail component */
const DiamondDetailPageComp = {
  rapnetRequestDiamonds: [],
  components: {
    diamondMediaGallery,
    FinalRingMediaGallery,
    diamondMetaData,
    diamondDetailTable,
    BreadcrumbsComp,
    RecentlyViewedItems,
    DetailSpinnerComp,
    WishlistPopupComp,
    HeaderStepsComp,
    StickyBarComp,
    DiamondCaratGraphicComp,
    DiamondCutGraphicComp,
    DiamondColorGraphicComp,
    DiamondClarityGraphicComp,
    DiamondSoldOutPopup,
  },
  data() {
    return {
      showSoldOutPopup: false,
      soldOutDiamond: null,
      diamond: {
        diamondId: "",
        dataNotFound: false,
        data: {},
        isInWishlist: false,
        wishlistText: "",
        wishlistClass: "",
        showTooltip: false,
      },
      pageMedia: [],
      loading: false,
      breadcrumbs: [],
      recentlyViewDiamonds: [],
      uniqueItemInRecentView: true,
      showRecentlyView: true,
      showWishlistPopup: false,
      WishlistPopupContent: "",
      wishlistItemName: "",
      showWishlistLoader: false,
      stepData: (function() {
        var fp = sessionStorage.getItem("firstPage");
        if (fp == "settingPage") {
          return { firstStep: { headerTitle: "SETTING" }, secondStep: { headerTitle: "DIAMOND" }, thirdStep: { headerTitle: "Ring" } };
        }
        return { firstStep: { headerTitle: "DIAMOND" }, secondStep: { headerTitle: "SETTING" }, thirdStep: { headerTitle: "Ring" } };
      })(),
      totalSteps: 1,
      pageStickyItems: [],
      showChangeDiamondPopup: false,
      isDiamondImgError: false,
      chooseButtonText: "Add This Diamond To Ring",
      chooseShowBtnLoader: false,
      changeDiamondWaringMsg: "",
      currentInfoTab: "table",
      addToCartButtonShouldShow: true,
      newlayout: false,
      productInWishList: false,
      coupon_ring_img: `${baseAssetsUrl}/bangles.png`,
      alexis: `${baseAssetsUrl}/alexis.png`,
      productStatus: "",
      redirectPage: "",
      hands: [
        "https://cdn.shopify.com/s/files/1/0900/1870/9868/files/hand1.jpg?v=1754051678",
        "https://cdn.shopify.com/s/files/1/0900/1870/9868/files/hand2.jpg?v=1754051678",
        "https://cdn.shopify.com/s/files/1/0900/1870/9868/files/hand3.jpg?v=1754051678",
      ],
      currentIndex: 0,
      carat: 1.0,
      minCarat: 0.5,
      maxCarat: 5.0,
      diamondImage:
        "https://cdn.shopify.com/s/files/1/0900/1870/9868/files/diamond.png?v=1754051677",
      basePxPerMM: 5, // Base scaling factor
    };
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.handleShopifySections();
      });
    },
    "$route.query.diamondId": {
      handler(diamondId) {
        setTimeout(() => {
          this.resetWindowToTop();
        }, 100);
        if (diamondId != undefined) {
          this.handleStepData();
          this.handleStickyBarItems();
          this.initializeDiamondState(diamondId);
          if (sessionStorage.getItem("selectedDiamond")) {
            this.checkAndSetDiamondDataFromSession();
          } else {
            this.loadDiamond();
          }
          this.checkWishlist(diamondId);
        }
      },
      immediate: true, // Set to true to trigger the handler immediately with the current value
    },
  },

  delimiters: ["[[", "]]"],
  template: "#product-detail-page",
  computed: {
    getBannerImgUrl() {
      return `${baseAssetsUrl}/got_question_banner.jpg`;
    },
    getDetailPageBannerUrl() {
      return `${baseAssetsUrl}/diamonds-banner.jpg`;
    },
    currentHand() {
      return this.hands[this.currentIndex];
    },
    diamondSize(data) {
      const mm = this.getDiamondMM(this.carat);
      // Adjust scaling based on screen size to maintain consistency
      const scaleFactor = window.innerWidth > 640 ? 1 : 0.8; // Reduce scale on mobile
      return data * this.basePxPerMM * scaleFactor;
    },
  },
  mounted() {
    this.handleShopifySections();
    this.checkAndHideSection();
    window.addEventListener("resize", () => {
      this.$forceUpdate(); // Recompute diamondSize on resize
    });
    if (!!sessionStorage.getItem("redirection")) {
      this.redirectPage = sessionStorage
        .getItem("redirection")
        .includes("-diamonds")
        ? "DIAMOND"
        : "SETTING";
    }
    if (!sessionStorage.getItem("firstPage")) {
      sessionStorage.setItem("firstPage", "diamondPage");
    }
    handlePageBodyClass("add", "pc-ringbuilder-diamond-detail-page");
    // document.querySelector('#header-banner .pc-top-banner-section picture img').style.display = 'none'
    var local = localStorage.getItem("new-layout");
    this.newlayout = !!local;
  },
  beforeUnmount() {
    this.restoreShopifySections();
    handlePageBodyClass("remove", "pc-ringbuilder-diamond-detail-page");
  },
  methods: {
    restoreShopifySections() {
      const sectionIds = [
        'shopify-section-template--24329029189996__apps_NeKKjU',
        'shopify-section-template--24329029189996__rich_text_EBMk9f'
      ];

      sectionIds.forEach(id => {
        const section = document.getElementById(id);
        if (section) {
          document.body.appendChild(section);
          section.classList.add('shopify-hidden');
          // Reset display style in case it was modified inline
          section.style.display = 'none';
        }
      });
    },
    handleShopifySections() {

      const section1 = document.querySelector(
        '.trustpilot-style-section'
      );

      const section2 = document.querySelector(
        '.review-style-section'
      );

      const target1 = document.querySelector('.custom-reviews-target');
      const target2 = document.querySelector('.custom-reviews-trustpilot');

      if (section1 && target1) {
        target1.appendChild(section1);
        section1.classList.remove('shopify-hidden');
        section1.style.display = '';
        this.reloadSection(section1);
      }

      if (section2 && target2) {
        target2.appendChild(section2);
        section2.classList.remove('shopify-hidden');
        section2.style.display = '';
        this.reloadSection(section2);
      }
    },
    reloadSection(section) {
      // 🔥 This is the magic line
      document.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          detail: { sectionId: section.id }
        })
      );

      // Swiper needs layout recalculation
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    },
    checkAndHideSection() {
      const path = window.location.pathname; // ✅ Shopify-safe

      const hideRoutes = [
        '/collections/coloured-lab-grown-diamonds/diamonds',
        '/collections/natural-diamonds/diamonds',
        '/collections/lab-diamonds/diamonds'
      ];

      if (hideRoutes.includes(path)) {
        // Retry in case Shopify loads section late
        setTimeout(() => {
          const section = document.getElementById(
            'shopify-section-template--26614716629356__order_includes_Jz7b6M'
          );
          if (section) {
            section.style.display = 'none';
          }
        }, 300);
      }
    },
    getDiamondMM(carat) {
      const sizes = [
        { carat: 0.5, mm: 5.2 },
        { carat: 1.0, mm: 6.5 },
        { carat: 1.5, mm: 7.4 },
        { carat: 2.0, mm: 8.2 },
        { carat: 3.0, mm: 9.4 },
        { carat: 5.0, mm: 11.1 },
      ];
      for (let i = 0; i < sizes.length - 1; i++) {
        if (carat <= sizes[i].carat) return sizes[i].mm;
      }
      return sizes[sizes.length - 1].mm;
    },
    functionOnConnect() {
      // window._klOnsite = window._klOnsite || [];
      // window._klOnsite.push(["openForm", "Xyi5kc"]);
      window.location.href = "/pages/contact-us";
    },
    resetAllSteps() {
      this.stepData = {
        firstStep: {
          headerTitle: "DIAMOND",
        },
        secondStep: {
          headerTitle: "SETTING",
        },
        thirdStep: {
          headerTitle: "Ring",
        },
      };
    },
    openDetail(e) {
      let element;
      if (e.target.nodeName == "svg") {
        element = e.target.parentElement;
        e.target.parentElement.classList.toggle("active");
      } else {
        element = e.target;
        e.target.classList.toggle("active");
      }
      element.classList.toggle("active");
      var panel = element.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } else {
        panel.style.maxHeight = null;
      }
      element.parentElement.classList.toggle("accordion-active");
      element.parentElement.classList.toggle("accordion-non-active");
    },
    openInfo(e) {
      let element;
      if (e.target.nodeName == "svg") {
        element = e.target.parentElement;
        e.target.parentElement.classList.toggle("active");
      } else {
        element = e.target;
        e.target.classList.toggle("active");
      }
      var panel = element.nextElementSibling;
      if (
        Array.from(element.parentElement.classList).includes("accordion-active")
      ) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
      element.classList.toggle("active");
      element.parentElement.classList.toggle("accordion-active");
      element.parentElement.classList.toggle("accordion-non-active");
    },
    startWith(pageType) {
      if (pageType == "setting") {
        window.location.href = "/collections/engagement-rings";
      } else {
        window.location.href = "/collections/lab-diamonds";
      }
    },
    checkAndSetDiamondDataFromSession() {
      var diamondData = JSON.parse(sessionStorage.getItem("selectedDiamond"));
      if (this.diamond.diamondId == diamondData.diamondId) {
        this.loading = true;
        this.diamond.data = this.convertCachedDiamond(diamondData);
        this.handleRecentlyViewItems(diamondData);
        this.handleMetaData();
        this.handleBreadcrumbs();
        this.buildDiamondPageMedia();
        this.loading = false;
      } else {
        this.loadDiamond();
      }
    },
    async buildDiamondPageMedia() {
      var media = [];
      var diamond = this.diamond && this.diamond.data;
      if (!diamond || !diamond.shape) {
        this.pageMedia = [];
        return;
      }
      // 1) Diamond video
      if (diamond.diamondVideo) {
        media.push({
          full: diamond.diamondVideo,
          thumbnail: null,
          name: "360° Diamond",
          type: "video",
        });
      }
      // 2) Diamond image – always show with shape fallback if missing
      var dImgUrl = (diamond.diamondImage && diamond.diamondImage.toLowerCase() !== 'na') ? diamond.diamondImage : getShapeFallbackImage(diamond.shape);
      media.push({
        full: dImgUrl,
        thumbnail: dImgUrl,
        popupUrl: dImgUrl,
        name: "diamond",
        type: "image",
        diamondShape: diamond.shape,
      });
      // 3) On-hand view → replaced by interactive Try-On cell
      media.push({
        type: "tryon",
        name: "Try-On",
      });
      // 4) Certificate
      if (diamond.certificateNumber || diamond.certificateFile) {
        media.push({
          type: "certificate",
          name: "Certificate",
          diamondData: diamond,
        });
      }
      // 5) Top view + Side view — separate tiles so each is full-size in the gallery
      var hasTop = diamond.shape && diamond.diamondType !== 'gemstone' && diamond.length && diamond.width;
      var hasSide = diamond.shape && diamond.diamondType !== 'gemstone' && diamond.tablePerc && diamond.deptPerc;
      if (hasTop) {
        var topUrl = await this.composeDiamondViewCanvas(diamond, 'front');
        if (topUrl) {
          media.push({
            full: topUrl,
            thumbnail: topUrl,
            popupUrl: topUrl,
            name: "Top View",
            type: "image",
          });
        }
      }
      if (hasSide) {
        var sideUrl = await this.composeDiamondViewCanvas(diamond, 'side');
        if (sideUrl) {
          media.push({
            full: sideUrl,
            thumbnail: sideUrl,
            popupUrl: sideUrl,
            name: "Side View",
            type: "image",
          });
        }
      }
      // 7) IGI certified banner
      var igiUrl = (typeof window !== "undefined" && window.__TRYON_ASSETS && window.__TRYON_ASSETS.igiCertBanner)
        || (baseAssetsUrl + '/igi-certified-banner-img.webp');
      media.push({
        full: igiUrl,
        thumbnail: igiUrl,
        name: "IGI Certified Banner",
        type: "image",
      });
      // 8) 30% off discount banner (matches final-ring gallery)
      var discountUrl = (typeof window !== "undefined" && window.__TRYON_ASSETS && window.__TRYON_ASSETS.discountBanner)
        || (baseAssetsUrl + '/70-discount-banner.png');
      media.push({
        full: discountUrl,
        thumbnail: discountUrl,
        name: "Discount Banner",
        type: "image",
      });
      this.pageMedia = media;
    },
    composeCombinedViewCanvas(diamond, hasTop, hasSide) {
      var self = this;
      return new Promise(function (resolve) {
        var tasks = [];
        tasks.push(hasTop ? self.composeDiamondViewCanvas(diamond, 'front') : Promise.resolve(null));
        tasks.push(hasSide ? self.composeDiamondViewCanvas(diamond, 'side') : Promise.resolve(null));
        Promise.all(tasks).then(function (urls) {
          var topUrl = urls[0];
          var sideUrl = urls[1];
          if (!topUrl && !sideUrl) { resolve(null); return; }
          // Each child is a physical 1500×920 PNG (child composer uses drawScale=2, dpr=2).
          var childW = 1500;
          var childH = 920;
          var canvas = document.createElement('canvas');
          canvas.width = childW * 2;
          canvas.height = childH;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#fff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          var imgs = [];
          var loaded = 0;
          var total = 0;
          if (topUrl) total++;
          if (sideUrl) total++;
          function onLoad() {
            loaded++;
            if (loaded === total) {
              try {
                for (var i = 0; i < imgs.length; i++) {
                  ctx.drawImage(imgs[i].el, imgs[i].x, 0);
                }
                resolve(canvas.toDataURL('image/png'));
              } catch (e) { resolve(null); }
            }
          }
          if (topUrl) {
            var t = new Image();
            imgs.push({ el: t, x: 0 });
            t.onload = onLoad;
            t.onerror = function () { loaded++; if (loaded === total) resolve(null); };
            t.src = topUrl;
          }
          if (sideUrl) {
            var s = new Image();
            imgs.push({ el: s, x: childW });
            s.onload = onLoad;
            s.onerror = function () { loaded++; if (loaded === total) resolve(null); };
            s.src = sideUrl;
          }
        });
      });
    },
    composeDiamondViewCanvas(diamond, viewType) {
      return new Promise(function (resolve) {
        try {
          var shape = String(diamond.shape || '').toLowerCase();
          var imgParams = DiamondCanvasComp.methods.getDiamondImgParams(shape);
          if (!imgParams || !Object.keys(imgParams).length) { resolve(null); return; }
          // drawScale = how much bigger the diagram is vs native PNG (makes text farther apart too)
          // dpr      = physical pixel density for crispness at high-res displays
          var drawScale = 2;
          var dpr = 2;
          var nativeW = 375;
          var nativeH = 230;
          var logicalW = nativeW * drawScale; // 750
          var logicalH = nativeH * drawScale; // 460
          var canvas = document.createElement('canvas');
          canvas.width = logicalW * dpr;       // 1500
          canvas.height = logicalH * dpr;      // 920
          var context = canvas.getContext('2d');
          context.scale(dpr, dpr);
          context.fillStyle = '#fff';
          context.fillRect(0, 0, logicalW, logicalH);
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            context.drawImage(img, 0, 0, logicalW, logicalH);
            context.font = 'bold 24px "Open Sans", Arial, sans-serif';
            context.textBaseline = 'alphabetic';
            context.lineJoin = 'round';
            context.lineWidth = 7;
            context.strokeStyle = 'rgba(255,255,255,0.95)';
            context.fillStyle = '#04043F';
            var pad = 8;
            function drawLabel(text, x, y) {
              context.strokeText(text, x, y);
              context.fillText(text, x, y);
            }
            // Coords from imgParams are in native 375×230 space — scale them up.
            function sx(v) { return v * drawScale; }
            function sy(v) { return v * drawScale; }
            if (viewType === 'front') {
              drawLabel(diamond.width + ' mm', sx(imgParams.width_width) + pad, sy(imgParams.width_height));
              drawLabel(diamond.length + ' mm', sx(imgParams.length_width), sy(imgParams.length_height) + pad);
            } else {
              var girdle = (!diamond.girdleMin || !diamond.girdleMax)
                ? 'None'
                : diamond.girdleMin + '-' + diamond.girdleMax;
              drawLabel(String(diamond.tablePerc), sx(imgParams.table_width) + pad, sy(imgParams.table_height));
              drawLabel(String(diamond.deptPerc), sx(imgParams.depth_width), sy(imgParams.depth_height) + pad);
              drawLabel(girdle, sx(imgParams.girdle_width), sy(imgParams.girdle_height) + pad);
            }
            try { resolve(canvas.toDataURL('image/png')); } catch (e) { resolve(null); }
          };
          img.onerror = function () { resolve(null); };
          img.src = baseAssetsUrl + '/' + shape + '_' + viewType + '.png';
        } catch (e) { resolve(null); }
      });
    },
    convertCachedDiamond(diamond) {
      diamond = getCurrencyWiseDiamond(diamond);
      return diamond;
    },
    resetWindowToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    addSelectedDiamond() {
      /* check selected diamond is compatible with selected setting or not if available */
      this.chooseButtonText = "Adding . . .";
      var diamondShape = this.diamond.data.shape;
      var firstPage = sessionStorage.getItem("firstPage");
      if (sessionStorage.getItem("selectedSetting")) {
        var selectedSetting = JSON.parse(
          sessionStorage.getItem("selectedSetting")
        );
        var settingCanBeSetWith =
          selectedSetting?.attribute_variations?.hasOwnProperty(
            this_ring_can_be_set_with
          )
            ? selectedSetting?.attribute_variations[
              this_ring_can_be_set_with
            ]?.map((shape) => shape.trim())
            : [];
        var selectedSettingConfiguration = JSON.parse(
          sessionStorage.getItem("selectedSettingOptions")
        );
        var settingDiamond = selectedSettingConfiguration.settingDiamondShape;
        if (
          !settingCanBeSetWith.includes(diamondShape) &&
          settingCanBeSetWith.length
        ) {
          this.showChangeDiamondPopup = true;
          this.changeDiamondWaringMsg = this.getWarningMsg(
            selectedSettingConfiguration.settingMetal
          );
        } else if (
          settingCanBeSetWith.length &&
          settingCanBeSetWith.includes(diamondShape) &&
          settingDiamond != "" &&
          settingDiamond.trim().toLowerCase() != diamondShape.toLowerCase() &&
          firstPage == "settingPage"
        ) {
          this.setNewSettingAsPerDiamond(diamondShape);
        } else {
          this.checkAndResetSelectedSetting(0);
        }
      } else {
        this.checkAndResetSelectedSetting(0);
      }
    },
    getWarningMsg(settingMetal) {
      return `The ${settingMetal} engagement ring which you have selected is not compatible with `;
    },
    setNewSettingAsPerDiamond(diamondShape) {
      var selectedSetting = JSON.parse(
        sessionStorage.getItem("selectedSetting")
      );
      var settingConfigOptions = JSON.parse(
        sessionStorage.getItem("selectedSettingOptions")
      );
      var settingVariations = selectedSetting?.variations;
      var currentSettingMetal = settingConfigOptions.settingMetal;
      var selectedDiamondShape = diamondShape;
      var newSettingId, newSettingMetal, newSettingDiamondShape;
      for (var settingSlug in settingVariations) {
        if (
          settingVariations[settingSlug].diamond.trim().toLowerCase() ==
          selectedDiamondShape.toLowerCase() &&
          settingVariations[settingSlug].metal.trim().toLowerCase() ==
          currentSettingMetal.toLowerCase()
        ) {
          newSettingId = settingVariations[settingSlug].variation_id;
          newSettingMetal = settingVariations[settingSlug].metal;
          newSettingDiamondShape = settingVariations[settingSlug].diamond;
        }
      }
      if (newSettingId) {
        this.changeSettingConfig(
          settingConfigOptions,
          newSettingId,
          newSettingMetal,
          newSettingDiamondShape
        );
        this.checkAndResetSelectedSetting(0);
      }
    },
    changeSettingConfig(
      settingConfigOptions,
      newSettingId,
      newSettingMetal,
      newSettingDiamondShape
    ) {
      settingConfigOptions.settingDiamondShape = newSettingDiamondShape;
      settingConfigOptions.settingId = newSettingId;
      settingConfigOptions.settingMetal = newSettingMetal;
      sessionStorage.setItem(
        "selectedSettingOptions",
        JSON.stringify(settingConfigOptions)
      );
    },
    // not in use
    // changeStickyBarItems(newSetting) {
    //   this.pageStickyItems = [];
    //   var firstPage = sessionStorage.getItem("firstPage");
    //   /* get diamond data */
    //   var diamond = this.diamond.data;
    //   var stepTitle = getDiamondTitle(diamond);
    //   var diamondData = {
    //     title: stepTitle.slice(0, 32) + (stepTitle.length > 33 ? "..." : ""),
    //     page: "diamond",
    //     imgUrl: diamond.diamondImage,
    //     placeholder: diamond.shape,
    //     price: `${diamond.currencySymbol}${parseFloat(
    //       diamond.finalPrice
    //     ).toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
    //     id: diamond.diamondId,
    //     diamondType: this.$route.params.diamondTab,
    //     cut: diamond.cut,
    //     clarity: diamond.clarity,
    //     color: diamond.color,
    //     lab: diamond.lab,
    //   };
    //   diamondData = appendCurrenciesToStickyBarItems(diamondData, diamond);
    //   /* get setting data */
    //   var settingConfigOptions = JSON.parse(
    //     sessionStorage.getItem("selectedSettingOptions")
    //   );
    //   var setting = newSetting;
    //   var settingData = {
    //     title:
    //       setting.name.slice(0, 32) + (setting.name.length > 33 ? "..." : ""),
    //     page: "setting",
    //     imgUrl: setting.main_image,
    //     placeholder: setting.main_image,
    //     price: `${setting.currency}${parseFloat(setting.price).toLocaleString(
    //       "en-US",
    //       { minimumFractionDigits: 2 }
    //     )}`,
    //     id: setting.id,
    //     metal: settingConfigOptions.settingMetal,
    //     size: settingConfigOptions.settingSize,
    //     sku: setting.sku,
    //     style: setting.attributes.Engagement_Ring_Style,
    //   };
    //   settingData = appendCurrenciesToStickyBarItems(settingData, setting);
    //   if (firstPage == "diamondPage") {
    //     this.pageStickyItems.push(diamondData, settingData);
    //   } else {
    //     this.pageStickyItems.push(settingData, diamondData);
    //   }
    //   sessionStorage.setItem(
    //     "stickyBarItems",
    //     JSON.stringify(this.pageStickyItems)
    //   );
    // },
    changeStepData(newSetting) {
      var firstPage = sessionStorage.getItem("firstPage");
      if (sessionStorage.getItem("stepData")) {
        this.stepData = JSON.parse(sessionStorage.getItem("stepData"));
      }
      if (firstPage == "settingPage") {
        this.stepData.firstStep.headerTitle = "SETTING";
        this.stepData.secondStep.headerTitle = "DIAMOND";
      } else if (firstPage == "diamondPage") {
        this.stepData.firstStep.headerTitle = "DIAMOND";
        this.stepData.secondStep.headerTitle = "SETTING";
      }
      this.setInitialTwoSteps(firstPage, newSetting);
    },
    setInitialTwoSteps(firstPage, newSetting) {
      if (firstPage == "diamondPage") {
        /* set first step for diamond*/
        var diamond = this.diamond.data;
        this.stepData.firstStep.headerTitle = "DIAMOND";
        var stepTitle = getDiamondTitle(diamond, this.$route.params.diamondTab);
        this.stepData.firstStep["price"] = `${diamond.currencySymbol
          }${parseFloat(diamond.finalPrice).toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`;
        this.stepData.firstStep["title"] = stepTitle;
        this.stepData.firstStep["isView"] = true;
        this.stepData.firstStep["isChange"] = true;
        this.stepData.firstStep["id"] = diamond.diamondId;
        this.stepData.firstStep["diamondType"] = this.$route.params.diamondTab;
        this.stepData.firstStep["page"] = "diamond";
        this.stepData.firstStep["diamondShape"] = diamond.shape;
        this.stepData.firstStep["placeholder"] = diamond.shape;
        this.stepData.firstStep["imgUrl"] = diamond.diamondImage;
        this.stepData.firstStep = appendCurrenciesToSteps(
          this.stepData.firstStep,
          diamond
        );

        /* set second step for setting */
        var setting = newSetting;
        this.stepData.secondStep.headerTitle = "SETTING";
        this.stepData.secondStep["title"] =
          setting.name.slice(0, 32) + (setting.name.length > 33 ? "..." : "");
        this.stepData.secondStep["price"] = `${setting.currency}${parseFloat(
          setting.price
        ).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
        this.stepData.secondStep["isView"] = true;
        this.stepData.secondStep["isChange"] = true;
        this.stepData.secondStep["id"] = setting.id;
        this.stepData.secondStep["handle"] = setting.handle || "";
        this.stepData.secondStep["page"] = "setting";
        this.stepData.secondStep["imgUrl"] = setting.main_image;
        this.stepData.secondStep["placeholder"] = setting.main_image;
        this.stepData.secondStep = appendCurrenciesToSteps(
          this.stepData.secondStep,
          setting
        );
      } else {
        /* set second step for diamond*/
        var diamond = this.diamond.data;
        this.stepData.secondStep.headerTitle = "DIAMOND";
        var stepTitle = getDiamondTitle(diamond, this.$route.params.diamondTab);
        this.stepData.secondStep["price"] = `${diamond.currencySymbol
          }${parseFloat(diamond.finalPrice).toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`;
        this.stepData.secondStep["title"] = stepTitle;
        this.stepData.secondStep["isView"] = true;
        this.stepData.secondStep["isChange"] = true;
        this.stepData.secondStep["id"] = diamond.diamondId;
        this.stepData.secondStep["diamondType"] = this.$route.params.diamondTab;
        this.stepData.secondStep["page"] = "diamond";
        this.stepData.secondStep["diamondShape"] = diamond.shape;
        this.stepData.secondStep["placeholder"] = diamond.shape;
        this.stepData.secondStep["imgUrl"] = diamond.diamondImage;
        this.stepData.secondStep = appendCurrenciesToSteps(
          this.stepData.secondStep,
          diamond
        );

        /* set first step for setting */
        var setting = newSetting;
        this.stepData.firstStep.headerTitle = "SETTING";
        this.stepData.firstStep["title"] =
          setting.name.slice(0, 32) + (setting.name.length > 33 ? "..." : "");
        this.stepData.firstStep["price"] = `${setting.currency}${parseFloat(
          setting.price
        ).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
        this.stepData.firstStep["isView"] = true;
        this.stepData.firstStep["isChange"] = true;
        this.stepData.firstStep["id"] = setting.id;
        this.stepData.firstStep["handle"] = setting.handle || "";
        this.stepData.firstStep["page"] = "setting";
        this.stepData.firstStep["imgUrl"] = setting.main_image;
        this.stepData.firstStep["placeholder"] = setting.main_image;
        this.stepData.firstStep = appendCurrenciesToSteps(
          this.stepData.firstStep,
          setting
        );
      }
      this.handleThirdStep(diamond);
      /* calculate totalSteps based on which steps actually have selections */
      var count = 0;
      if (this.stepData.firstStep && this.stepData.firstStep.title) count++;
      if (this.stepData.secondStep && this.stepData.secondStep.title) count++;
      if (this.stepData.thirdStep && this.stepData.thirdStep.title) count++;
      /* ensure current step (diamond) is at least highlighted */
      var fp = sessionStorage.getItem("firstPage");
      var currentStepPos = (fp == "settingPage") ? 2 : 1;
      this.totalSteps = Math.max(count, currentStepPos);
      sessionStorage.setItem("stepData", JSON.stringify(this.stepData));
    },
    setNewImage(targetElement, diamondShape) {
      var stage = parseInt(targetElement.dataset.imgErrorStage || "0");
      targetElement.dataset.imgErrorStage = String(stage + 1);
      if (stage === 0) {
        this.isDiamondImgError = true;
        targetElement.setAttribute("src", getShapeFallbackImage(diamondShape));
      } else if (stage === 1) {
        targetElement.setAttribute("src", shapeToImageUrl.DEFAULT);
      }
    },
    initializeDiamondState(diamondId) {
      var diamond = this.diamond;
      diamond.diamondId = diamondId;
      diamond.dataNotFound = false;
      diamond.data = {};
      // diamond.isInWishlist = false
      diamond.wishlistText = "";
      diamond.showTooltip = false;
      diamond.wishlistClass = "";
      this.breadcrumbs = [];
      this.recentlyViewDiamonds = [];
      this.uniqueItemInRecentView = true;
      if (window.innerWidth <= 676) {
        this.showRecentlyView = false;
      }
    },
    handleRecentlyViewItems(diamondJson) {
      this.setRecentlyViewedDiamondsForListing(diamondJson);
      if (!sessionStorage.getItem("ringbuilderRecentlyView")) {
        this.uniqueItemInRecentView = true;
        this.recentlyViewDiamonds.push(diamondJson);
        sessionStorage.setItem(
          "ringbuilderRecentlyView",
          JSON.stringify(this.recentlyViewDiamonds)
        );
      } else {
        this.recentlyViewDiamonds = JSON.parse(
          sessionStorage.getItem("ringbuilderRecentlyView")
        );
        let isExistDiamond = this.recentlyViewDiamonds.find((curDiamond) => {
          return curDiamond.diamondId == diamondJson.diamondId;
        });
        if (isExistDiamond === undefined) {
          this.recentlyViewDiamonds.push(diamondJson);
          if (this.recentlyViewDiamonds.length > 12)
            this.recentlyViewDiamonds.shift();
          sessionStorage.setItem(
            "ringbuilderRecentlyView",
            JSON.stringify(this.recentlyViewDiamonds)
          );
        }
      }
      if (this.recentlyViewDiamonds.length < 2) {
        this.recentlyViewDiamonds = [];
      } else {
        this.recentlyViewDiamonds = this.recentlyViewDiamonds.filter(
          (diamond) => {
            if (this.diamond.diamondId != diamond.diamondId) {
              return diamond;
            }
          }
        );
      }
      this.convertRecentlyViewedDiamonds();
    },
    convertRecentlyViewedDiamonds() {
      this.recentlyViewDiamonds = this.recentlyViewDiamonds?.map((diamond) => {
        diamond = getCurrencyWiseDiamond(diamond);
        return diamond;
      });
    },
    setRecentlyViewedDiamondsForListing(diamondJson) {
      var viewedDiamonds = [];
      if (sessionStorage.getItem("ringbuilderRecentlyViewForListing")) {
        viewedDiamonds = JSON.parse(
          sessionStorage.getItem("ringbuilderRecentlyViewForListing")
        );
      }
      if (viewedDiamonds.length) {
        var isDiamondExist = viewedDiamonds.find((curDiamond) => {
          return curDiamond.diamondId == diamondJson.diamondId;
        });
        if (isDiamondExist === undefined) {
          viewedDiamonds.push(diamondJson);
        }
      } else {
        viewedDiamonds.push(diamondJson);
      }
      sessionStorage.setItem(
        "ringbuilderRecentlyViewForListing",
        JSON.stringify(viewedDiamonds)
      );
    },
    handleBreadcrumbs() {
      this.breadcrumbs = [];
      var diamondType;
      if (this.$route.params.diamondTab.includes("natural-color")) {
        diamondType = "natural-fancy-coloured-diamonds";
      } else if (this.$route.params.diamondTab.includes("coloured-lab-grown")) {
        diamondType = "coloured-lab-grown-diamonds";
      } else if (this.$route.params.diamondTab.includes("natural")) {
        diamondType = "natural-diamonds";
      } else if (this.$route.params.diamondTab.includes("lab")) {
        diamondType = "lab-diamonds";
      } else {
        diamondType = "fancy-diamonds";
      }
      var typeLabel;
      if (diamondType == "coloured-lab-grown-diamonds") {
        typeLabel = "Coloured Lab Grown";
      } else if (diamondType == "natural-fancy-coloured-diamonds") {
        typeLabel = "Coloured Natural";
      } else if (diamondType == "lab-diamonds") {
        typeLabel = "Lab Grown";
      } else if (diamondType == "natural-diamonds") {
        typeLabel = "Natural";
      } else {
        typeLabel = "Coloured";
      }
      var diamondShape = this.diamond.data ? this.diamond.data.shape : "";
      var shapeLabel = `${diamondShape || ""}`
        .split(" ")
        .filter((word) => word)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
      // Same trail as the listing page ("Coloured Lab Grown Diamonds /
      // Round Coloured Lab Grown Diamonds"), then the diamond itself.
      const chooseDiamondsUrl = {
        path: `/collections/${diamondType}`,
        name: `${typeLabel} Diamonds`,
      };
      const shapeUrl = shapeLabel
        ? {
            path: `/collections/${diamondType}/${shapeLabel.toLowerCase()}`,
            name: `${shapeLabel} ${typeLabel} Diamonds`,
          }
        : null;
      // Pass the type through so the crumb reads exactly like the page title,
      // e.g. "1.03 Carat Round Green Coloured Lab Grown Diamond".
      const diamondName = this.diamond.dataNotFound
        ? "No Diamond Found"
        : getDiamondTitle(this.diamond.data, diamondType);
      const diamondIdUrl = {
        path: `/collections/${diamondType}/diamonds?diamondId=${this.$route.query.diamondId}`,
        name: diamondName,
      };
      this.breadcrumbs = [chooseDiamondsUrl, shapeUrl, diamondIdUrl].filter(
        (crumb) => !!crumb
      );
    },
    addToWishlist(diamondId) {
      var diamond = this.diamond.data;
      this.showWishlistLoader = true;
      const diamondName = getDiamondTitle(diamond);
      setTimeout(() => {
        this.showWishlistLoader = false;
        var wishlistItems = JSON.parse(localStorage.getItem("wishlistItems") || "[]");
        if (!wishlistItems.includes(diamondId)) {
          wishlistItems.push(diamondId);
          sessionStorage.setItem("status", "Great choice! This product has been added to your wishlist.");
        } else {
          sessionStorage.setItem("status", "Already exist in your wishlist");
        }
        localStorage.setItem("wishlistItems", JSON.stringify(wishlistItems));
        this.diamond.isInWishlist = true;
        this.showWishlistPopup = true;
        this.wishlistItemName = `${diamondName} Diamond`;
      }, 300);
    },
    checkWishlist(diamondId) {
      const wishlistItems =
        localStorage.getItem("wishlistItems") != null
          ? JSON.parse(localStorage.getItem("wishlistItems"))
          : "";
      if (wishlistItems.length) {
        wishlistItems?.map((storedWishlistDiamondId) => {
          if (storedWishlistDiamondId == diamondId) {
            this.diamond.isInWishlist = this.isInWishlist = true;
          }
        });
      }
      sessionStorage.setItem("checkEngageDiaId", diamondId);
    },
    goBack() {
      var diamondType = this.$route.params.diamondTab.toLowerCase();
      // if (this.$route.params.diamondTab.toLowerCase().includes('natural')) {
      //     diamondType = 'natural-diamonds'
      // } else if (this.$route.params.diamondTab == 'lab') {
      //     diamondType = 'lab-diamonds'
      // } else {
      //     diamondType = 'fancy-diamonds'
      // }
      sessionStorage.setItem("isDiamondDetailPageViewed", 1);
      var shapename = localStorage.getItem("shapename");
      /* if (sessionStorage.getItem("firstPage")) {
                var firstPage = sessionStorage.getItem("firstPage")
                if (firstPage == 'settingPage') {
                    this.$router.push({name : "chooseDiamonds", params : {diamondType}})                       
                } else {
                    this.$router.push({name : "chooseDiamonds", params : {diamondType}})
                }
                return     
            } */
      this.$router.replace({
        path: `/${diamondType}${shapename ? `/${shapename}` : ""}`,
      });
    },
    checkDiamond(datas) {
      this.showBtnTooltip = false;
      this.btnTooltipText = "";
      this.loading = false;
    },
    loadDiamond() {
      this.loading = true;

      if (
        !this.$options.rapnetRequestDiamonds.includes(
          this.$route.params.diamondTab.toLowerCase()
        )
      ) {
        axios({
          url: api,
          method: "post",
          data: {
            query: `{
                        ${diamondDetailApiFunc}(diamondId:"${this.diamond.diamondId
              }",diamondType:"${this.$route.params.diamondTab
                .toLowerCase()
                .includes("natural-diamond")
                ? "white" : this.$route.params.diamondTab
                  .toLowerCase()
                  .includes("natural-fancy-coloured-diamonds") ? "white_color" :
                  this.$route.params.diamondTab
                    .toLowerCase()
                    .includes("lab-diamond") ? "lab" :
                    this.$route.params.diamondTab
                      .toLowerCase()
                      .includes("coloured-lab-grown-diamonds") ? "lab_color"
                      : this.$route.params.diamondTab
                        .toLowerCase()
              }") {
                            diamond{
  diamondId
  shape
  caratWeight
  color
  clarity
  cut
  symmetry
  polish
  deptPerc
  tablePerc
  length
  width
  depth
  ratio
  girdleMin
  girdleMax
  finalPriceAud
  culet
  fancyColor
  flourIntensity
  certificateFile
  lab                                              
                                   ${graphQLCurrencyFields()}
  certificateNumber
  stockNumber
  diamondImage
  diamondVideo
  diamondType
  currencyCode
  currencySymbol
  sellerName
  availability
}
                            }
                        }`,
          },
        })
          .then((response) => {
            const arr = response.data.data[diamondDetailApiFunc].diamond;
            if (arr && arr.length) {
              const rawDiamond = arr[0];
              const isSoldOut = /sold|out of stock|unavailable/i.test(String(rawDiamond.availability || ""));
              if (isSoldOut) {
                this.diamond.dataNotFound = false;
                this.diamond.data = this.getConvertedDiamonds(rawDiamond);
                this.handleRecentlyViewItems(this.diamond.data);
                this.handleMetaData();
                this.handleBreadcrumbs();
                this.buildDiamondPageMedia();
                this.productStatus = "Failed";
                this.loading = false;
                this.soldOutDiamond = this.diamond.data;
                this.showSoldOutPopup = true;
                if (window.ROADiamond) {
                  window.ROADiamond.clearBuilderSelection(this.diamond.data.diamondId);
                }
              } else {
                this.diamond.dataNotFound = false;
                this.diamond.data = this.getConvertedDiamonds(rawDiamond);
                this.handleRecentlyViewItems(this.diamond.data);
                this.handleMetaData();
                this.handleBreadcrumbs();
                this.buildDiamondPageMedia();
                this.showBtnTooltip = false;
                this.btnTooltipText = "";
                this.productStatus = "";
                this.loading = false;
              }
            } else {
              this.diamond.dataNotFound = false;
              this.productStatus = "Failed";
              this.loading = false;
              const stone = {
                diamondId: this.diamond.diamondId,
                diamondType: this.$route.params.diamondTab,
              };
              this.soldOutDiamond = stone;
              this.showSoldOutPopup = true;
              if (window.ROADiamond) {
                window.ROADiamond.clearBuilderSelection(stone.diamondId);
              }
            }
          })
          .catch((err) => {
            this.diamond.dataNotFound = true;
            this.loading = false;
            this.handleMetaData();
            this.handleBreadcrumbs();
          });
      } else {
        this.diamond.dataNotFound = true;
        this.loading = false;
        this.handleMetaData();
        this.handleBreadcrumbs();
      }
    },
    getConvertedDiamonds(diamond) {
      diamond = getCurrencyWiseDiamond(diamond);
      return diamond;
    },
    changeCurrentDiamond(action) {
      if (action == "yes") {
        sessionStorage.removeItem("settingDetailPageViewedId");
        this.checkAndResetSelectedSetting(1);
        this.showChangeDiamondPopup = false;
      } else {
        this.checkAndSendToFinalPage();
      }
    },
    checkAndSendToFinalPage() {
      firstPage = sessionStorage.getItem("firstPage");
      if (
        sessionStorage.getItem("selectedDiamond") != null &&
        sessionStorage.getItem("selectedSetting") != null
      ) {
        var selectedSetting = JSON.parse(
          sessionStorage.getItem("selectedSetting")
        );
        var selectedDiamond = JSON.parse(
          sessionStorage.getItem("selectedDiamond")
        );
        var settingId = selectedSetting?.id;
        var diamondId = selectedDiamond.diamondId;
        var diamondType = selectedDiamond.diamondType;
        // buildFinalRingUrl (ring-builder-common-components.js) is the single source
        // of truth for this URL's shape; a hard navigation (not router.push) is
        // required to cross the base-path boundary reliably, same as handleSettingMsgAndRout.
        var href = buildFinalRingUrl({ settingId, diamondId, diamondType });
        if (href) window.location.href = `${baseUrl}${href}`;
        return;
      } else {
        if (firstPage == "settingPage") {
          this.$router.push({
            name: "chooseDiamonds",
            params: { diamondType: "natural-diamonds" },
          });
        } else {
          this.$router.push({
            name: "chooseDiamonds",
            params: { diamondType: "natural-diamonds" },
            query: { pageType: "diamond" },
          });
        }
      }
    },
    checkAndResetSelectedSetting(resetSetting) {
      var isSelectedSettingRested = 0;
      if (sessionStorage.getItem("selectedSetting") && resetSetting) {
        /* reset steps */
        this.resetSteps();
        /* remove setting and it's configuration from session storage */
        sessionStorage.removeItem("selectedSetting");
        sessionStorage.removeItem("selectedSettingOptions");
        /* remove sticky bar */
        sessionStorage.removeItem("stickyBarItems");
        /* remove step data */
        sessionStorage.removeItem("stepData");
        /* remove setting listing applied filters */
        sessionStorage.removeItem("chooseSettingsAppliedFilters");
        /* handle step data and sticky bar items */
        this.handleStepData(this.diamond.data);
        this.handleStickyBarItems(this.diamond.data);
        isSelectedSettingRested = 1;
      } else {
        /* handle step data and sticky bar items */
        this.handleStepData(this.diamond.data);
        this.handleStickyBarItems(this.diamond.data);
        isSelectedSettingRested = 0;
      }
      this.saveCurrentDiamond();
      this.handleSettingMsgAndRout(isSelectedSettingRested);
    },
    resetSteps() {
      var firstPage = sessionStorage.getItem("firstPage");
      if (firstPage == "settingPage") {
        this.stepData = {
          firstStep: { headerTitle: "SETTING" },
          secondStep: { headerTitle: "DIAMOND" },
          thirdStep: { headerTitle: "Ring" },
        };
      } else {
        this.stepData = {
          firstStep: { headerTitle: "DIAMOND" },
          secondStep: { headerTitle: "SETTING" },
          thirdStep: { headerTitle: "Ring" },
        };
      }
    },
    saveCurrentDiamond() {
      /* set selected setting's data in session storage */
      sessionStorage.setItem(
        "selectedDiamond",
        JSON.stringify(this.diamond.data)
      );

      const selectedSecondDiamond = JSON.parse(
        sessionStorage.getItem("selectedSecondDiamond")
      );

      if (selectedSecondDiamond) {
        if (
          this.diamond.data.diamondType != selectedSecondDiamond?.diamondType
        ) {
          sessionStorage.removeItem("selectedSecondDiamond");
        }
      }
      sessionStorage.removeItem("redirection");
    },
    handleSettingMsgAndRout(isSelectedSettingRested) {
      this.diamond.showTooltip = true;
      this.diamond.wishlistText = "Diamond selected";
      this.diamond.wishlistClass = "tps_ring_selected";
      // Both diamond and setting are now selected — redirect to final-ring
      // instantly, with no artificial delay (unlike the other branches below,
      // which still wait to let their toast/tooltip messages show).
      if (!isSelectedSettingRested && sessionStorage.getItem("selectedSetting")) {
        this.diamond.showTooltip = false;
        var diamondId = this.diamond.diamondId;
        var selectedSetting = JSON.parse(
          sessionStorage.getItem("selectedSetting")
        );
        var settingId = selectedSetting?.id;
        var diamondType = this.diamond.data.diamondType;
        // No data= payload: selectedSetting/selectedDiamond are already in
        // sessionStorage (this is a same-browser redirect) and final-ring's
        // mounted() reads them from there — avoids risking a 414 on rich settings.
        // Always land on /collections/final-ring — a hard navigation (not
        // router.push) is required to cross the base-path boundary reliably.
        // buildFinalRingUrl (ring-builder-common-components.js) is the single source
        // of truth for this URL's shape, shared with the header steps bar's "View"
        // link/click — so this redirect always matches finalRingHref exactly.
        var href = buildFinalRingUrl({ settingId, diamondId, diamondType });
        if (href) window.location.href = `${baseUrl}${href}`;
        return;
      }
      setTimeout(() => {
        this.diamond.showTooltip = false;
        firstPage = sessionStorage.getItem("firstPage");
        if (isSelectedSettingRested) {
          if (firstPage == "settingPage") {
            window.location.href = "/collections/engagement-rings";
          } else {
            window.location.href = "/collections/lab-diamonds";
          }
        } else {
          var componentName = "chooseSetting";
          this.$router.push({
            name: componentName,
            // path: "/collections/engagement-rings"
          });
        }
      }, 2000);
    },
    handleStepData(diamond = "") {
      var firstPage = sessionStorage.getItem("firstPage");
      if (sessionStorage.getItem("stepData")) {
        this.stepData = JSON.parse(sessionStorage.getItem("stepData"));
        // Guard against a stale/mismatched cache: only trust a step's cached title/price
        // if it still points at what's actually selected right now. Prevents a step
        // showing blank (or the wrong item) when the cache wasn't updated in lockstep
        // with the real selection (e.g. a setting picked earlier that isn't reflected
        // here yet, or a step left over from a sold-out diamond).
        var realSetting = safeParseJSON("selectedSetting");
        var realDiamond = safeParseJSON("selectedDiamond");
        ["firstStep", "secondStep"].forEach((key) => {
          var step = this.stepData[key];
          if (!step) return;
          if (step.page === "setting" && (!realSetting || String(step.id) !== String(realSetting.id))) {
            this.stepData[key] = { headerTitle: step.headerTitle };
          } else if (step.page === "diamond" && (!realDiamond || String(step.id) !== String(realDiamond.diamondId))) {
            this.stepData[key] = { headerTitle: step.headerTitle };
          }
        });
      }
      if (firstPage == "settingPage") {
        this.stepData.firstStep.headerTitle = "SETTING";
        this.stepData.secondStep.headerTitle = "DIAMOND";
        /* handle diamond price for second step */
        this.stepData.secondStep = this.getConvertedStepPrice(
          this.stepData.secondStep
        );
        /* handle setting price for first step */
        this.stepData.firstStep = this.getConvertedStepPrice(
          this.stepData.firstStep
        );
      } else if (firstPage == "diamondPage") {
        this.stepData.firstStep.headerTitle = "DIAMOND";
        this.stepData.secondStep.headerTitle = "SETTING";
        /* handle diamond price for first step */
        this.stepData.firstStep = this.getConvertedStepPrice(
          this.stepData.firstStep
        );
        /* handle setting price for second step */
        this.stepData.secondStep = this.getConvertedStepPrice(
          this.stepData.secondStep
        );
      }
      /* handle third step as per currency */
      this.stepData.thirdStep = this.getConvertedStepPrice(
        this.stepData.thirdStep
      );
      if (diamond) {
        /* handle first and second steps */
        var stepTitle = getDiamondTitle(diamond, this.$route.params.diamondTab);
        var price = `${diamond.currencySymbol}${parseFloat(
          diamond.finalPrice
        ).toLocaleString("en-US", { minimumFractionDigits: 2 })
          } `;
        if (firstPage == "diamondPage") {
          this.stepData.firstStep["title"] = stepTitle;
          this.stepData.firstStep["price"] = price;
          this.stepData.firstStep["isView"] = true;
          this.stepData.firstStep["isChange"] = true;
          this.stepData.firstStep["id"] = diamond.diamondId;
          this.stepData.firstStep["diamondType"] =
            this.$route.params.diamondTab;
          this.stepData.firstStep["page"] = "diamond";
          this.stepData.firstStep["diamondShape"] = diamond.shape;
          this.stepData.firstStep["placeholder"] = diamond.shape;
          this.stepData.firstStep["imgUrl"] = diamond.diamondImage;
          this.stepData.firstStep = appendCurrenciesToSteps(
            this.stepData.firstStep,
            diamond
          );
        } else {
          this.stepData.secondStep["title"] = stepTitle;
          this.stepData.secondStep["price"] = price;
          this.stepData.secondStep["isView"] = true;
          this.stepData.secondStep["isChange"] = true;
          this.stepData.secondStep["id"] = diamond.diamondId;
          this.stepData.secondStep["diamondType"] =
            this.$route.params.diamondTab;
          this.stepData.secondStep["page"] = "diamond";
          this.stepData.secondStep["diamondShape"] = diamond.shape;
          this.stepData.secondStep["placeholder"] = diamond.shape;
          this.stepData.secondStep["imgUrl"] = diamond.diamondImage;
          this.stepData.secondStep = appendCurrenciesToSteps(
            this.stepData.secondStep,
            diamond
          );
        }
        /* handle third step */
        this.handleThirdStep(diamond);
        sessionStorage.setItem("stepData", JSON.stringify(this.stepData));
      }
      /* calculate totalSteps based on which steps actually have selections */
      var count = 0;
      if (this.stepData.firstStep && this.stepData.firstStep.title) count++;
      if (this.stepData.secondStep && this.stepData.secondStep.title) count++;
      if (this.stepData.thirdStep && this.stepData.thirdStep.title) count++;
      /* ensure current step (diamond) is at least highlighted */
      var fp = sessionStorage.getItem("firstPage");
      var currentStepPos = (fp == "settingPage") ? 2 : 1;
      this.totalSteps = Math.max(count, currentStepPos);
    },
    getConvertedStepPrice(step) {
      if (step.hasOwnProperty("price")) {
        step = getCurrencyWiseStep(step);
      }
      return step;
    },
    handleThirdStep(diamond) {
      if (sessionStorage.getItem("selectedSetting")) {
        var diamond = diamond;
        var setting = JSON.parse(sessionStorage.getItem("selectedSetting"));
        var price = `${diamond.currencySymbol}${(
          parseFloat(diamond.finalPrice) + parseFloat(setting.price)
        ).toLocaleString("en-US", { minimumFractionDigits: 2 })
          } `;
        var stepTitle = `${setting.name} With ${getDiamondTitle(diamond, diamond.diamondType)}`;
        this.stepData.thirdStep["title"] = stepTitle;
        this.stepData.thirdStep["price"] = price;
        this.stepData.thirdStep["isReset"] = true;
        this.stepData.thirdStep["isView"] = true;
        this.stepData.thirdStep["id"] = "";
        this.stepData.thirdStep["page"] = "ring";
        this.stepData.thirdStep["diamondId"] = diamond.diamondId;
        this.stepData.thirdStep["diamondType"] = diamond.diamondType;
        this.stepData.thirdStep["settingId"] = setting.id;
        this.stepData.thirdStep["imgUrl"] = setting.main_image;
        this.stepData.thirdStep = appendCurrenciesToFinalSteps(
          this.stepData.thirdStep,
          diamond,
          setting
        );
      } else {
        this.stepData.thirdStep.headerTitle = "Ring";
      }
    },
    // in use
    handleStickyBarItems(diamond = "") {
      var sessionStickyBarItems = [];
      if (sessionStorage.getItem("stickyBarItems")) {
        sessionStickyBarItems = JSON.parse(
          sessionStorage.getItem("stickyBarItems")
        );
      }
      if (diamond) {
        var stepTitle =
          `${!diamond.caratWeight
            ? ""
            : parseFloat(diamond.caratWeight) + "-Carat"
          } ` + ` ${!diamond.shape ? "" : diamond.shape + " Shape"} `;
        let diamondData = {
          title: stepTitle.slice(0, 32) + (stepTitle.length > 33 ? "..." : ""),
          page: "diamond",
          imgUrl: diamond.diamondImage,
          placeholder: diamond.shape,
          price: `${diamond.currencySymbol}${parseFloat(
            diamond.finalPriceAud
          ).toLocaleString("en-US", { minimumFractionDigits: 2 })
            } `,
          id: diamond.diamondId,
          diamondType: this.$route.params.diamondTab,
          cut: diamond.cut,
          clarity: diamond.clarity,
          color: diamond.color,
          lab: diamond.lab,
        };
        diamondData = appendCurrenciesToStickyBarItems(diamondData, diamond);
        if (!sessionStickyBarItems.length) {
          sessionStickyBarItems.push(diamondData);
        } else if (
          sessionStickyBarItems.length < 2 &&
          sessionStickyBarItems.length > 0
        ) {
          for (var index in sessionStickyBarItems) {
            if (sessionStickyBarItems[index].page != "diamond") {
              sessionStickyBarItems.push(diamondData);
            } else {
              sessionStickyBarItems[index] = diamondData;
            }
          }
        } else {
          for (var index in sessionStickyBarItems) {
            if (sessionStickyBarItems[index].page == "diamond") {
              sessionStickyBarItems[index] = diamondData;
            }
          }
        }
        sessionStorage.setItem(
          "stickyBarItems",
          JSON.stringify(sessionStickyBarItems)
        );
      }
      this.pageStickyItems = this.getConvertedStickyBarItems(
        sessionStickyBarItems
      );
    },
    getConvertedStickyBarItems(stickyBarItems) {
      if (stickyBarItems.length) {
        stickyBarItems?.map((stickyBarItem) => {
          if (stickyBarItem.hasOwnProperty("price")) {
            stickyBarItem = getCurrencyWiseStickyItem(stickyBarItem);
          }
        });
      }
      return stickyBarItems;
    },
    getPageUrl() {
      return `${baseUrl} /${this.$route.params.diamondTab}/diamonds ? diamondId = ${this.$route.query.diamondId} `;
    },
    getMetaData(type) {
      const diamond = this.diamond.data;
      switch (type) {
        case "description":
          return `Shop the ${getDiamondTitle(diamond)} at Rings of Australia. Certified diamond with exceptional cut, clarity and brilliance. Get 30% off today with free insured shipping.`;
        case "imgUrl":
          if (
            diamond.diamondImage &&
            diamond.diamondImage != "" &&
            diamond.diamondImage != "N/A"
          ) {
            return diamond.diamondImage;
          } else {
            return `${window.location.origin} /cdn/shop / t / 9 / assets / ${diamond.shape}.png`;
          }
        case "title":
          let title;
          if (!Object.keys(diamond).length) {
            title = "No Diamond Found";
          } else {
            title = getDiamondTitle(diamond);
          }
          return title;
        case "siteName":
          return "Vue Woocomerce";
        case "type":
          return "product";
        case "sku":
          return diamond.diamondId;
        case "category":
          return "Loose Diamonds";
        case "price":
          return diamond.finalPrice;
        case "currency":
          return diamond.currencyCode;
        case "availability":
          return "in stock";
        case "id":
          return diamond.diamondId;
        case "googleCategory":
          return "Apparel & Accessories > Jewelry";
      }
    },
    handleMetaData() {
      document.title = this.getMetaData("title") + " | Rings of Australia";
      /* set default and openGraph meta data for filter page */
      const meta = [
        { name: "description", content: this.getMetaData("description") },
        { property: "og:title", content: this.getMetaData("title") },
        { property: "og:site_name", content: "Rings of Australia" },
        { property: "og:type", content: this.getMetaData("type") },
        { property: "og:url", content: window.location.href },
        { property: "og:image", content: this.getMetaData("imgUrl") },
        {
          property: "og:description",
          content: this.getMetaData("description"),
        },
        { property: "og:sku", content: this.getMetaData("sku") },
        { property: "og:category", content: this.getMetaData("category") },
        { property: "og:price:amount", content: this.getMetaData("price") },
        {
          property: "og:price:currency",
          content: this.getMetaData("currency"),
        },
        {
          property: "og:availability",
          content: this.getMetaData("availability"),
        },
        { property: "og:id", content: this.getMetaData("id") },
        {
          property: "og:google_product_category",
          content: this.getMetaData("googleCategory"),
        },
      ];
      setMetaData("meta", meta);
    },
  },
  beforeMount() {
    document.getElementById("initial-page-loader").style.display = "none";
    let elements = document.getElementsByClassName("js-recently-view");
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.display = "block";
    }
  },
};
